'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringify = stringify;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function stringify(value, key) {
  var accumulator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (_lodash2.default.isObject(value)) {
    var primitiveArray = _lodash2.default.isArray(value) && !_lodash2.default.some(value, _lodash2.default.isObject);
    return _lodash2.default.reduce(value, function (result, nestedValue, nestedKey) {
      var encodedKey = primitiveArray ? '' : encodeURIComponent(nestedKey);
      var prefixedKey = key ? key + '[' + encodedKey + ']' : encodedKey;
      return stringify(nestedValue, prefixedKey, result);
    }, accumulator);
  }

  if (_lodash2.default.isNil(value)) {
    return accumulator;
  }

  if (!key) {
    throw new Error('Top level serialized value must be object or array');
  }

  return (accumulator ? accumulator + '&' : accumulator) + key + '=' + encodeURIComponent(value);
}

exports.default = {
  stringify: stringify
};